"use client";

import { createImageSizes, createImageUrl } from "@/utils/image";
import Image from "next/image";
import Script from "next/script";
import { useRef, useState, type MouseEvent } from "react";

type Props = {
  imageUrl: string;
  src: string;
  appVersion: string;
  videoTitle: string;
  isApp: boolean;
  streamUrl?: string | null;
  duration?: number | null;
  isLive?: boolean;
};

export default function ArticleVideoPlayer({
  imageUrl,
  src,
  videoTitle,
  isApp,
  streamUrl,
  duration,
  isLive,
  appVersion,
}: Props) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [, setSdkReady] = useState(false);

  if (iframeRef !== null) {
    // TMP Merge app play and iframe while debugging remove this and button when done.
    // Revert this commit once done
    function handleOverlayClick(event: MouseEvent) {
      event.preventDefault();
      event.stopPropagation();
      console.log(`handleOverlayClick streamUrl`, streamUrl);
      console.log(`handleOverlayClick videoTitle`, videoTitle);
      window.postMessage(
        {
          type: "play",
          videoUrl: streamUrl,
          videoTitle: videoTitle,
        },
        window.location.origin,
      );
    }

    return (
      <>
        <Script
          src="https://cdn.screen9.com/players/iframe-api.js"
          strategy="afterInteractive"
          onReady={() => setSdkReady(true)}
        />
        <div className="aspect-w-16 aspect-h-9">
          <iframe
            ref={iframeRef}
            title={videoTitle ?? "VideoSpelare"}
            src={src}
            allowFullScreen
          />
        </div>
        <button type="button" onClick={handleOverlayClick} className="opacity-0 absolute block">
          Starta
        </button>
      </>
    );
  }

  if (imageUrl !== "") {
    return (
      <div className="aspect-w-16 aspect-h-9">
        <Image
          fill
          src={createImageUrl(imageUrl)}
          alt={imageUrl}
          className="object-cover"
          sizes={createImageSizes({
            desktop: "33vw",
            tablet: "50vw",
            mobile: "100vw",
          })}
        />
      </div>
    );
  }
}
